<mat-card class="curtains">
  <div class="repair-timeline">
    <div>
      @if (job?.repairTimelineDate) {
        <div class="received-date">
          {{ job?.repairTimelineDate | dateepoch: currentTimezone }}
          {{ job?.repairTimelineDate | time: currentTimezone }}
        </div>
      }
      <h5 class="repair-timeline-header">Repair Timeline</h5>
    </div>
    <div class="repair-timeline-body">
      @if (job?.authorityDate) {
        <div class="repair-timeline-body-part">
          <div class="repair-timeline-body-part-authorized">
            <div class="repair-timeline-body-part-authorized-title body-1">Authorised</div>
            <div class="repair-timeline-body-part-authorized-date body-2">
              {{ job?.authorityDate | momentTz: currentTimezone }}
            </div>
          </div>
        </div>
      }
      @for (timelineBox of timelineBoxes; track timelineBox) {
        <app-repair-timeline-box
          [timelineBox]="timelineBox"
          [editDisabled]="isEditionDisabled || userService.isRepairerSiteSuspended()"
          (editRepairTimeline)="editRepairTimeline.emit()"
          [currentTimezone]="currentTimezone"></app-repair-timeline-box>
      }
    </div>
    @if (!(isEditionDisabled || userService.isRepairerSiteSuspended())) {
      <div class="repair-timeline-footer">
        <button matIconButton (click)="editRepairTimeline.emit()">
          <mat-icon class="mat-icon-edit">edit</mat-icon>
        </button>
      </div>
    }
  </div>
</mat-card>
